// https://www.stabpad.com/sign/gaiapiercings0@gmail.com/Gaia_Piercings

import SignaturePad from "react-signature-canvas";
import { useCallback, useRef } from "react";
import { useState, useEffect } from "react";
import ArmoMail from "./armoMail";
import { useLocation } from "react-router-dom";
import { useCliente } from "../../actions/clientes";
import Webcam from "react-webcam";
import { toast } from "react-toastify"; // ✅ Usar react-hot-toast

import "./contrato.css";

export default function Contrato() {
   const [currentRecord, setCurrentRecord] = useState(0);
   const [records, setRecords] = useState([]);
   const [grabar, setGrabar] = useState(true);
   const { SaveCliente } = useCliente();
   const [firmaArtistaPreview, setFirmaArtistaPreview] = useState(null);
   const [firmaClientePreview, setFirmaClientePreview] = useState(null);
   const artistSignaturePadRef = useRef();
   // State for image upload and preview
   // const [uploadedImage, setUploadedImage] = useState(null);
   const [imagenes, setImagenes] = useState([]); // Array de imágenes
   const [imagePreview, setImagePreview] = useState(null);

   const webcamRef = useRef(null);
   const [showWebcam, setShowWebcam] = useState(false);
   const [facingMode, setFacingMode] = useState("user"); // "user" = frontal, "environment" = trasera
   // asignar getUserMedia
   const [stream, setStream] = useState(null);
   const [hasCamera, setHasCamera] = useState(false);

   const clienteSignaturePadRef = useRef();
   const location = useLocation();
   // Control menor 18
   const [isUnder18, setIsUnder18] = useState(false);
   const [tutorName, setTutorName] = useState("");
   const [firmaTutorPreview, setFirmaTutorPreview] = useState(null);
   const tutorSignaturePadRef = useRef();

   useEffect(() => {
      // Si viene un id en el state y es distinto de 0, buscar los datos
      if (location.state && location.state.id && location.state.id !== 0) {
         console.log("location.state.id: ", location.state.id);
         fetch(process.env.REACT_APP_URL_DIR + "contrato/" + location.state.id)
            .then((res) => res.json())
            .then((data) => {
               if (data && data.length > 0) {
                  setRecords(data);
                  // Carga el primer registro por defecto
                  loadRecord(data[0]);
                  setCurrentRecord(0);
               }
               setGrabar(false);
            });
      }
   }, [location.state]);

   // Función para inicializar getUserMedia
   const initializeCamera = async () => {
      try {
         const mediaStream = await navigator.mediaDevices.getUserMedia({
            video: {
               facingMode: facingMode,
               width: { ideal: 400 },
               height: { ideal: 300 },
            },
            audio: false,
         });

         setStream(mediaStream);
         setHasCamera(true);

         // Asignar stream al webcam ref
         if (webcamRef.current && webcamRef.current.video) {
            webcamRef.current.video.srcObject = mediaStream;
         }
      } catch (error) {
         console.error("Error accessing camera:", error);
         setHasCamera(false);
         toast.error(
            "No se pudo acceder a la cámara. Por favor, verifica los permisos."
         );
      }
   };

   // Función para detener el stream
   const stopCamera = () => {
      if (stream) {
         stream.getTracks().forEach((track) => {
            track.stop();
         });
         setStream(null);
      }
   };

   // Verificar disponibilidad de cámaras
   const checkCameraAvailability = async () => {
      try {
         const devices = await navigator.mediaDevices.enumerateDevices();
         const videoDevices = devices.filter(
            (device) => device.kind === "videoinput"
         );
         return videoDevices.length > 0;
      } catch (error) {
         console.error("Error checking camera availability:", error);
         return false;
      }
   };

   // useEffect para verificar cámara al montar el componente
   useEffect(() => {
      checkCameraAvailability().then(setHasCamera);

      // Cleanup: detener cámara al desmontar
      return () => {
         stopCamera();
      };
   }, []);

   // useEffect para reinicializar cámara cuando cambia facingMode
   useEffect(() => {
      if (showWebcam && hasCamera) {
         stopCamera();
         setTimeout(() => {
            initializeCamera();
         }, 100);
      }
   }, [facingMode, showWebcam]);

   const switchCamera = () => {
      setFacingMode((prevMode) =>
         prevMode === "user" ? "environment" : "user"
      );
   };
   // Modificar la función para abrir webcam
   const openWebcam = async () => {
      if (!hasCamera) {
         const available = await checkCameraAvailability();
         if (!available) {
            toast.error("No se detectaron cámaras disponibles en este dispositivo.");
            return;
         }
         setHasCamera(true);
      }

      setShowWebcam(true);
      await initializeCamera();
   };

   // Modificar la función para cerrar webcam
   const closeWebcam = () => {
      stopCamera();
      setShowWebcam(false);
   };
   function loadRecord(record) {
      setFields(record.fields || Array(7).fill(""));
      setCliente(record.cliente || Array(9).fill(""));
      setProvisions(record.provisions || Array(9).fill(""));
      setYnState(record.ynState || Array(8).fill(null));
      // const dobValue = cliente[8] || "";
      // setDobYear(dobValue ? dobValue.split("-")[0] : "");
      // setDobMonth(dobValue ? dobValue.split("-")[1] : "");
      // setDobDay(dobValue ? dobValue.split("-")[2] : "")  ;

      if (record.imagen) {
         try {
            const imagenesArray =
               typeof record.imagen === "string"
                  ? JSON.parse(record.imagen)
                  : record.imagen;
            setImagenes(imagenesArray || []);
         } catch (error) {
            console.error("Error parsing imagenes:", error);
            setImagenes([]);
         }
      }
      if (record.firmaArtista) setFirmaArtistaPreview(record.firmaArtista);
      if (record.firmaCliente) setFirmaClientePreview(record.firmaCliente);
      if (record.tutorName) setTutorName(record.tutorName);
      if (record.firmaTutor) setFirmaTutorPreview(record.firmaTutor);
      age(record.cliente[8]);
   }
   // State for enlarged declaro modal
   const [showDeclaroModal, setShowDeclaroModal] = useState(false);
   const url = process.env.REACT_APP_URL_DIR + "contrato";
   const urlMail = process.env.REACT_APP_URL_DIR + "mailer";
   const declaroText = `Declaro ser responsable de la persona descrita como “cliente” en este documento. He sido debidamente Informado(a) acerca del procedimiento de la perforación corporal. Estoy al tanto que los insumos como joyería y accesorios son biocompatibles y tales como agujas, guantes, gasas, etc., son estériles y desechables y/o instrumental reutilizable ha sido debidamente procesado y esterilizado para su uso. También me han explicado claramente el procedimiento a realizar y las reacciones del cuerpo luego del procedimiento, así como también me explicarán los cuidados posteriores a seguir, que además he recibido por mail. Entiendo que el correcto cuidado posterior del cliente es esencial para la correcta cicatrización. Yo como cliente o el portador del procedimiento me comprometo a asistir a Diamante Tattoo Studio en donde se realizó el procedimiento para supervisar su correcta evolución y resolver cualquier duda que pueda presentarse posteriormente. He recibido el teléfono y correo electrónico u otro método de contacto de quien me ha realizado el procedimiento para contactar en caso de dudas, problemas o urgencias relacionadas al procedimiento realizado. He sido informado de los riesgos asociados a las perforaciones corporales, entiendo que estos riesgos pueden conllevar a una infección, formación de granulomas y/o queloides o alguna otra complicación y asumo la total responsabilidad, por lo tanto, libero de toda responsabilidad a Diamante Tattoo Studio, al perforador (a) y sus empleados de cualquier forma y tipo de responsabilidad, reclamos, acción, demanda y compensación, que yo o cualquier otra persona, relacionada directa o indirectamente con el cliente ahora o en lo sucesivo, por ninguna razón relacionada con mi pedido de ser perforador, o intervenido el cuerpo del “cliente”. Estando de acuerdo con las capacidades y certificación de Diamante Tattoo Studio, declaro ser mayor de edad y responsable de quien se describe en este documento como “cliente”. No me encuentro intoxicado, ni bajo la influencia de ninguna droga o sustancia que pudiera afectar mi voluntad y sano juicio para tomar la decisión de hacer el procedimiento de perforación o modificación corporal. Certifico que bajo mi pedido se realizará un procedimiento en un ambiente limpio y con material estéril a la persona mencionada como “cliente” en este documento quien no padece de ninguna enfermedad o alteración fisiológica, psicológica o social que pudiese complicar o alterar la normal cicatrización del trabajo a realizar. En caso de cualquier problema básico, asistiré o llevaré a la persona portadora del trabajo realizado a las dependencias de Diamante Tattoo Studio, en los horarios de atención del local. En caso de un problema mayor y si no pudiese asistir al local mencionado, acepto asistir o llevar a la persona portadora del procedimiento a un médico, asumiendo el costo, pues entiendo que de no recibir atención pronta el problema puede agravarse drásticamente. Estoy de acuerdo que, en caso de arrepentirme y no llevar a cabo el procedimiento, considerando que el perforador ha preparado la mesa de trabajo y ha abierto el material estéril, deberé pagar la suma de $7000, debido que se considera material perdido.`;
   // const enviarEmail = async () => {
   //    const asunto = "Nuevo contrato recibido";
   //    const texto = ArmoMail({ cliente, fields, firmaBase64: "firmaBase64" });
   //    console.log("fields: ", fields);
   //    console.log("cliente: ", cliente);
   //    console.log("enviarEmail: ", texto);
   //    // await handleSendMail(cliente[4], asunto, texto);
   // };
   const handleSubmit = async (e) => {
      e.preventDefault();

      const formData = new FormData();
      // const firmaBase64 = artistSignaturePadRef.current.getTrimmedCanvas().toDataURL("image/png");
      const firmaBase64 = artistSignaturePadRef?.current
         .getCanvas()
         .toDataURL("image/png");
      const firmaBase64C = clienteSignaturePadRef?.current
         .getCanvas()
         .toDataURL("image/png");

      // Agregar firma del tutor si es menor de 18
      let firmaBase64T = null;
      if (isUnder18 && tutorSignaturePadRef?.current) {
         firmaBase64T = tutorSignaturePadRef.current
            .getCanvas()
            .toDataURL("image/png");
      }

      formData.append("provisions", JSON.stringify(provisions));
      formData.append("fields", JSON.stringify(fields));
      formData.append("ynState", JSON.stringify(ynState));
      formData.append("cliente", JSON.stringify(cliente));
      formData.append("firmaArtista", firmaBase64);
      formData.append("firmaCliente", firmaBase64C);
      console.log("formData 0: ", formData);
      console.log("imagenes.length: ", imagenes.length);
      if (imagenes.length > 0) {
         formData.append("imagenes", JSON.stringify(imagenes));
      }
      // Agregar datos del tutor si existe
      if (isUnder18) {
         formData.append("tutorName", tutorName);
         if (firmaBase64T) {
            formData.append("firmaTutor", firmaBase64T);
         }
      } else {
         formData.append("tutorName", "");
         formData.append("firmaTutor", "");
      }

      const Clidata = {
         id_primary: -1,
         id: 0,
         companyId: 0,
         nombre: cliente[1],
         documento: cliente[0],
         email: cliente[4],
         telefono: cliente[3],
         cod_status: "1",
      };
      // salvo Cliente
      console.log('Clidata: ', Clidata,cliente);
      await SaveCliente.mutateAsync(Clidata);

      // for (let pair of formData.entries()) {
      //    console.log(pair[0], pair[1]);
      // }

      // Subir imagen a /api/uploads si existe
      // let imagePath = null;
      // if (uploadedImage) {
      //    console.log("uploadedImage: ", uploadedImage);
      //    const imgForm = new FormData();
      //    imgForm.append("image", uploadedImage);
      //    try {
      //       const uploadRes = await fetch(
      //          process.env.REACT_APP_URL_DIR + "contrato/upload",
      //          {
      //             method: "POST",
      //             body: imgForm,
      //          }
      //       );
      //       if (uploadRes.ok) {
      //          const data = await uploadRes.json();
      //          imagePath = data.path || data.imagePath || data.url;
      //          console.log("imagePath: ", imagePath);
      //          console.log("data.url: ", data.url);
      //          console.log("data.imagePath: ", data.imagePath);
      //          console.log("data.path: ", data.path);
      //       } else {
      //          alert("Error al subir la imagen");
      //          return;
      //       }
      //    } catch (err) {
      //       console.log("err: ", err);
      //       alert("Error de red al subir la imagen");
      //       return;
      //    }
      // } else {
      //    const imgForm = new FormData();
      //    imgForm.append("image", "");
      //    console.log("no Image: ", imgForm);
      // }
      // if (imagePath) {
      //    formData.append("image", imagePath);
      // }

      // for (let pair of formData.entries()) {
      //    console.log(pair[0] + ": " + pair[1]);
      // }
      console.log("formData 1: ", formData);
      try {
         const res = await fetch(url, {
            method: "POST",
            body: formData,
         });
         if (res.ok) {
            toast.success("Formulario enviado correctamente");
            // Redirigir o realizar alguna acción adicional
            const asunto = "Nuevo contrato recibido";
            console.log("JSON.stringify(imagenes): ", JSON.stringify(imagenes));
            const texto = ArmoMail(
               cliente,
               fields,
               provisions,
               ynState,
               JSON.stringify(imagenes)
            );
            console.log("mail: ", cliente[4], asunto, texto);
            await handleSendMail(cliente[4], asunto, texto);

            window.location.href = "/contratop";
         } else {
            const asunto = "Error en contrato recibido";
            console.log("asunto: ", asunto);
            const texto = "diamantetattoo@gmail.com"; //ArmoMail(cliente, fields);
            await handleSendMail(cliente[4], asunto, texto);
            toast.error("Error al enviar el formulario");
         }
      } catch {
         toast.error("Error de red al enviar el formulario");
      }
   };

   const handleSendMail = async (email, asunto, texto) => {
      try {
         const res = await fetch(urlMail, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, asunto, texto }),
         });
         if (!res.ok) {
            toast.error("Error al enviar el correo");
         }
      } catch {
         toast.error("Error de red al enviar el correo");
      }
   };

   // Handler for image upload
   // const handleImageChange = (e) => {
   //    const file = e.target.files[0];
   //    if (file) {
   //       setUploadedImage(file);
   //       const reader = new FileReader();
   //       reader.onloadend = () => {
   //          setImagePreview(reader.result);
   //       };
   //       reader.readAsDataURL(file);
   //    } else {
   //       setUploadedImage(null);
   //       setImagePreview(null);
   //    }
   // };
   // Each provision is a single string
   const [provisions, setProvisions] = useState(Array(9).fill(""));
   const [cliente, setCliente] = useState(Array(9).fill(""));
   const [fields, setFields] = useState(Array(7).fill(""));
   const [ynState, setYnState] = useState([
      "n", // pregunta 0
      "n", // pregunta 1
      "n", // pregunta 2
      "n", // pregunta 3
      "n", // pregunta 4
      "n", // pregunta 5
      "n", // pregunta 7
      "n", // pregunta 8
   ]);
   function clearCanvas(canvasId) {
      console.log("clearCanvas");
      console.log("ynState: ", ynState);
      console.log("fields: ", fields);
      console.log("provisions: ", provisions);
      console.log("cliente: ", cliente);
      const canvas = document.getElementById(canvasId);
      if (canvas && canvas.getContext) {
         setYnState(["n", "n", "n", "n", "n", "n", "n", "n"]);
         setProvisions(Array(9).fill(""));
         setCliente(Array(9).fill(""));
         setFields(Array(7).fill(""));
         const ctx = canvas.getContext("2d");
         ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
   }
   const handleProvisionChange = (idx, value) => {
      setProvisions((clie) => {
         const next = [...clie];
         next[idx] = value;
         return next;
      });
   };
   const handleClienteChange = (idx, value) => {
      setCliente((prev) => {
         const next = [...prev];
         next[idx] = value;
         return next;
      });
      if (idx === 8 && value.length === 10) {
         age(value);
      }
   };
   // Función para alternar el color entre azul y gris
   function yn_select2(idx, val) {
      setYnState((prev) => {
         const next = [...prev];
         next[idx] = val;
         return next;
      });
   }
   function yn_select3(idx) {
      const checkbox = document.getElementById(`switch_${idx}`);
      if (checkbox.checked) {
         yn_select2(idx, "y");
      } else {
         yn_select2(idx, "n");
      }
   }

   const enviarEmail = async () => {
      console.log("fields: ", fields);
      console.log("cliente: ", cliente);
      console.log("provisions: ", provisions);
      console.log("ynState: ", ynState);
      console.log("imagePreview: ", imagePreview);
      const asunto = "Nuevo contrato recibido";
      const texto = ArmoMail(cliente, fields, provisions, ynState, imagenes);
      console.log("enviarEmail: ", texto);
      await handleSendMail(cliente[4], asunto, texto);
      alert("Mail Enviado");
   };

   function age(id) {
      // console.log("cliente[8]: ", id);
      if (!id || id === "") {
         console.log("Fecha de nacimiento no válida");
         return;
      }
      const day = parseInt(id.substring(8, 10), 10);
      const month = parseInt(id.substring(5, 7), 10) - 1; // JS months are 0-based
      const year = parseInt(id.substring(0, 4), 10);

      if (
         isNaN(day) ||
         isNaN(month) ||
         isNaN(year) ||
         day < 1 ||
         month < 0 ||
         year < 1900
      ) {
         document.getElementById("dob_age_display").innerText = "";
         setIsUnder18(false);
         // Limpiar fecha de nacimiento en cliente
         setCliente((prev) => {
            const next = [...prev];
            next[8] = "";
            return next;
         });
         return;
      }

      const today = new Date();
      const birthDate = new Date(year, month, day);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
         age--;
      }
      console.log("age: ", age);

      document.getElementById("dob_age_display").innerText = `Edad: ${age}`;
      // document.getElementById("dob_age").value = age;

      // Guardar fecha de nacimiento en cliente[8] (formato YYYY-MM-DD)
      setCliente((prev) => {
         const next = [...prev];
         const mm = (month + 1).toString().padStart(2, "0");
         const dd = day.toString().padStart(2, "0");
         next[8] = `${year}-${mm}-${dd}`;
         return next;
      });

      if (age < 18) {
         document.getElementById("age_note").style.display = "block";
         setIsUnder18(true);
      } else {
         document.getElementById("age_note").style.display = "none";
         setIsUnder18(false);
         // Limpiar datos del tutor si ya no es menor
         setTutorName("");
         setFirmaTutorPreview(null);
      }
   }

   // Handler para actualizar el array fields
   const handleFieldChange = (idx, value) => {
      setFields((prev) => {
         const next = [...prev];
         next[idx] = value;
         return next;
      });
   };

   // Función mejorada para capturar imagen
   const capture = useCallback(() => {
      if (webcamRef.current) {
         try {
            const imageSrc = webcamRef.current.getScreenshot();
            if (imageSrc) {
               // Agregar la nueva imagen al array
               setImagenes((prev) => [
                  ...prev,
                  {
                     id: Date.now(),
                     data: imageSrc,
                     timestamp: new Date().toISOString(),
                     facingMode: facingMode, // Guardar qué cámara se usó
                  },
               ]);
               closeWebcam(); // Cerrar cámara después de capturar
               setImagePreview(null);
            }
         } catch (error) {
            console.error("Error capturing image:", error);
            alert("Error al capturar la imagen. Intenta nuevamente.");
         }
      }
   }, [webcamRef, facingMode]);

   // Función para eliminar una imagen específica
   const eliminarImagen = (imageId) => {
      setImagenes((prev) => prev.filter((img) => img.id !== imageId));
   };

   // Función para limpiar todas las imágenes
   const limpiarTodasImagenes = () => {
      setImagenes([]);
      setImagePreview(null);
   };

   // Usar en cada pregunta:

   console.log("records: ", records);

   return (
      <>
         <form
            name="MyForm"
            id="MyForm"
            autoComplete="off"
            acceptCharset="utf-8"
            // onSubmit={handleSubmit}
         >
            {/* Cabecera */}
            <fieldset className="action">
               <h1>Diamante Piercings</h1>
            </fieldset>
            {records.length > 1 && (
               <div
                  style={{
                     margin: "16px 0",
                     textAlign: "center",
                     color: "#fffcfcff",
                  }}
               >
                  <button
                     onClick={() => {
                        const prev = Math.max(currentRecord - 1, 0);
                        setCurrentRecord(prev);
                        loadRecord(records[prev]);
                     }}
                     disabled={currentRecord === 0}
                     style={{ marginRight: "12px" }}
                  >
                     Anterior
                  </button>
                  <span>
                     Registro {currentRecord + 1} de {records.length}
                  </span>
                  <button
                     onClick={() => {
                        const next = Math.min(
                           currentRecord + 1,
                           records.length - 1
                        );
                        setCurrentRecord(next);
                        loadRecord(records[next]);
                     }}
                     disabled={currentRecord === records.length - 1}
                     style={{ marginLeft: "12px" }}
                  >
                     Siguiente
                  </button>
               </div>
            )}

            {/* Datos del Practicante */}
            <fieldset id="top">
               <br />
               <div className="legend">
                  Datos a llenar por el/la Practicante
               </div>
               {/* <div className="legend">Déjenos hacer esta parte.</div> */}
               <div className="label">Fecha de hoy:</div>
               <div style={{ display: "none" }}>
                  <input
                     className="input"
                     type="text"
                     name="date"
                     id="date_data"
                  />
               </div>
               <div className="value">
                  <span id="todays_date">Mon Jul 28 2025 03:50</span>
               </div>
               <div className="break"></div>
               <div className="label" id="input_artist">
                  Practicante:<span className="required">*</span>
               </div>
               <select
                  onChange="artist_select(this)"
                  onBlur="return artist_select_ios6(this)"
                  size="1"
                  name="artist"
               >
                  <option value="-1"> -- Seleccione -- </option>
                  <option value="Gaia" selected>
                     Gaia
                  </option>
                  <option value="!other">Other</option>
               </select>
               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_0" className="label">
                     Zona del cuerpo:<span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        name="fields[0]"
                        type="text"
                        className="required input_text"
                        value={fields[0]}
                        onChange={(e) => handleFieldChange(0, e.target.value)}
                     />
                  </div>
               </div>

               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_1" className="label">
                     Tipo de joyería:<span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        type="text"
                        className="required input_text"
                        name="fields[1]"
                        value={fields[1]}
                        onChange={(e) => handleFieldChange(1, e.target.value)}
                     />
                  </div>
               </div>
               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_2" className="label">
                     Medida especifica:<span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        type="text"
                        className="required input_text"
                        name="fields[2]"
                        value={fields[2]}
                        onChange={(e) => handleFieldChange(2, e.target.value)}
                     />
                  </div>
               </div>

               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_3" className="label">
                     Tipo de accesorio:<span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        type="text"
                        className="required input_text"
                        name="fields[3]"
                        value={fields[3]}
                        onChange={(e) => handleFieldChange(3, e.target.value)}
                     />
                  </div>
               </div>

               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_4" className="label">
                     Material:<span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        type="text"
                        className="required input_text"
                        name="fields[4]"
                        value={fields[4]}
                        onChange={(e) => handleFieldChange(4, e.target.value)}
                     />
                  </div>
               </div>

               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_5" className="label">
                     Tiempo minimo de cicatrización:
                     <span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        type="text"
                        className="required input_text"
                        name="fields[5]"
                        value={fields[5]}
                        onChange={(e) => handleFieldChange(5, e.target.value)}
                     />
                  </div>
               </div>

               <div className="break"></div>
               <div className="provision_text">
                  <div id="input_field_6" className="label">
                     Valor de trabajo:<span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        type="text"
                        className="required input_text"
                        name="fields[6]"
                        value={fields[6]}
                        onChange={(e) => handleFieldChange(6, e.target.value)}
                     />
                  </div>
               </div>

               <div className="break"></div>
               <div id="input_artist_signature" className="label">
                  Firma del artista:<span className="required">*</span>
               </div>
               <br />
               <span className="clear_signature_container">
                  <input
                     //className="clear_signature"
                     type="button"
                     value="Limpiar"
                     onClick={() => clearCanvas("signature_artist")}
                  />
               </span>
               {firmaArtistaPreview ? (
                  <div style={{ margin: "16px 0" }}>
                     <div>Firma del artista:</div>
                     <img
                        src={firmaArtistaPreview}
                        alt="Firma artista"
                        style={{
                           maxWidth: "300px",
                           maxHeight: "120px",
                           border: "1px solid #ccc",
                           borderRadius: "8px",
                        }}
                     />
                  </div>
               ) : (
                  <div style={{ margin: "16px 0" }}>
                     <SignaturePad
                        canvasProps={{
                           width: 635,
                           height: 240,
                           style: {
                              border: "1px solid #aeaeaeff",
                              borderRadius: "8px",
                           },
                        }}
                        ref={artistSignaturePadRef}
                     />
                     <button
                        type="button"
                        style={{ marginTop: "8px" }}
                        onClick={() => artistSignaturePadRef.current.clear()}
                     >
                        Limpiar Firma Digital
                     </button>
                  </div>
               )}
            </fieldset>

            {/* Texto de declaracion */}
            <fieldset
               id="declaro"
               className="declaro"
               onClick={() => setShowDeclaroModal(true)}
               style={{ cursor: "pointer" }}
            >
               {declaroText}
               <br />
            </fieldset>

            {/* Cuestionario */}
            <fieldset>
               <br />
               <div className="legend">Por Favor lea y responda</div>
               <div id="input_provision_0"></div> {/* Pregunta 0 */}
               <label className="switch">
                  <input
                     id="switch_0"
                     type="checkbox"
                     checked={ynState[0] === "y"}
                     onClick={() => yn_select3(0)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[0] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[0] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[0] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Consentimiento<span className="required">*</span>
               </span>
               <div className="declaro">
                  De acuerdo a las condiciones antes escritas, doy mi
                  consentimiento para realizar la perforación corporal.
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     name="provisions[0]"
                     type="text"
                     className="input_text"
                     value={provisions[0]}
                     onChange={(e) => handleProvisionChange(0, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               {/* <br/> */}
               <div id="input_provision_1"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_1"
                     type="checkbox"
                     checked={ynState[1] === "y"}
                     onClick={() => yn_select3(1)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[1] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[1] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[1] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Embarazo<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Estás embarazada o en periodo de lactancia?
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[1]"
                     type="text"
                     value={provisions[1]}
                     onChange={(e) => handleProvisionChange(1, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_2"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_2"
                     type="checkbox"
                     checked={ynState[2] === "y"}
                     onClick={() => yn_select3(2)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[2] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[2] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[2] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Alimentación<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Has comido en las últimas 4 hs? Es una buena idea hacerlo de
                  antemano para aumentar los niveles de azúcar en la sangre.
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[2]"
                     type="text"
                     value={provisions[2]}
                     onChange={(e) => handleProvisionChange(2, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_3"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_3"
                     type="checkbox"
                     checked={ynState[3] === "y"}
                     onClick={() => yn_select3(3)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[3] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[3] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[3] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Antecedentes de salud<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Tiene algún patógeno transmitido por sangre, enfermedades
                  transmisibles o enfermedades recientes? (Esto es confidencial)
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[3]"
                     type="text"
                     value={provisions[3]}
                     onChange={(e) => handleProvisionChange(3, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_4"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_4"
                     type="checkbox"
                     checked={ynState[4] === "y"}
                     onClick={() => yn_select3(4)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[4] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[4] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[4] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Tratamientos<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Tiene algún tratamiento médico? ¿Cuál?
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[4]"
                     type="text"
                     value={provisions[4]}
                     onChange={(e) => handleProvisionChange(4, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_5"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_5"
                     type="checkbox"
                     checked={ynState[5] === "y"}
                     onClick={() => yn_select3(5)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[5] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[5] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[5] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Anticoagulantes<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Has tomado aspirinas o alcohol en las ultimas 12-24 hs?
                  ¿Cuál?
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[5]"
                     type="text"
                     value={provisions[5]}
                     onChange={(e) => handleProvisionChange(5, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_6"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_6"
                     type="checkbox"
                     checked={ynState[6] === "y"}
                     onClick={() => yn_select3(6)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[6] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[6] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[6] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Tabaco y drogas<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Fumas tabaco o consume algún tipo de drogas? ¿Cuál? (Esto es
                  confidencial)
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[6]"
                     type="text"
                     value={provisions[6]}
                     onChange={(e) => handleProvisionChange(6, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_7"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_7"
                     type="checkbox"
                     checked={ynState[7] === "y"}
                     onClick={() => yn_select3(7)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[7] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[7] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[7] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Alergias<span className="required">*</span>
               </span>
               <div className="declaro">
                  ¿Posee reacciones alérgicas adversas ante agentes externos?
                  (Níquel, antisépticos, químicos, tintas, látex, etc.)
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[7]"
                     type="text"
                     value={provisions[7]}
                     onChange={(e) => handleProvisionChange(7, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               <div id="input_provision_8"></div>{" "}
               <label className="switch">
                  <input
                     id="switch_8"
                     type="checkbox"
                     checked={ynState[8] === "y"}
                     onClick={() => yn_select3(8)}
                  />
                  <span className="slider round">
                     <span
                        style={{
                           marginLeft: ynState[8] === "y" ? "10px" : "35px",
                           marginTop: "5px",
                           fontWeight: "bold",
                           fontSize: "24px",
                           color: ynState[8] === "y" ? "#067d22ff" : "#dc3545",
                        }}
                     >
                        {ynState[8] === "y" ? "Si" : "No"}
                     </span>
                  </span>
               </label>
               <span className="provision_title">
                  Fotografía<span className="required">*</span>
               </span>
               <div className="declaro">
                  Libero todos los derechos sobre cualquier fotografía que se me
                  tome de la perforación y doy mi consentimiento por adelantado
                  para su reproducción en forma impresa o electrónica.
               </div>
               <div className="provision_text">
                  <div className="label">Details:</div>
                  <input
                     className="input_text"
                     name="provisions[8]"
                     type="text"
                     value={provisions[8]}
                     onChange={(e) => handleProvisionChange(8, e.target.value)}
                  />
                  &nbsp;
               </div>
               <br />
               Gracias por elegirme y confiar en mi trabajo.
               <br />
            </fieldset>

            {/* Datos del Cliente */}
            <fieldset>
               <br />
               <div className="legend">Información del Cliente</div>
               Por la presente declaro que soy mayor de edad (con prueba válida
               de edad) y soy competente para firmar este Acuerdo. o, en caso
               contrario, que mi padre o tutor legal firme en mi nombre, y que
               mi padre o tutor legal entienda y esté de acuerdo con este
               acuerdo.
               <div className="break"></div>
               <div id="input_name" className="label">
                  Documento:<span className="required">*</span>
               </div>
               <div className="value">
                  <input
                     style={{
                        fontSize: 16,
                        padding: "4px 12px",
                        borderRadius: 6,
                        width: "20%",
                        border: "1px solid #bbb",
                     }}
                     placeholder="Numero de documento"
                     id="cliente[0]"
                     name="cliente[0]"
                     type="text"
                     autoComplete="off_16"
                     value={cliente[0]}
                     onChange={(e) => handleClienteChange(0, e.target.value)}
                  />
               </div>
               <div className="break"></div>
               <div id="input_name" className="label">
                  Nombre:<span className="required">*</span>
               </div>
               <div className="value">
                  <input
                     style={{
                        fontSize: 16,
                        padding: "4px 12px",
                        borderRadius: 6,
                        width: "50%",
                        border: "1px solid #bbb",
                     }}
                     placeholder="Nombre y Apellido"
                     id="cliente[1]"
                     name="cliente[1]"
                     type="text"
                     autoComplete="off_16"
                     value={cliente[1]}
                     onChange={(e) => handleClienteChange(1, e.target.value)}
                  />
               </div>
               <div className="break"></div>
               <div id="input_address" className="label">
                  Direccion:
               </div>
               <div className="value">
                  <input
                     className="input_text"
                     placeholder="Numero de calle, nombre de calle, estado y barrio"
                     id="cliente[2]"
                     name="cliente[2]"
                     type="text"
                     autoComplete="off_20"
                     value={cliente[2]}
                     onChange={(e) => handleClienteChange(2, e.target.value)}
                  />
               </div>
               <div className="break"></div>
               <div id="input_dob" className="label">
                  Fecha de nacimiento:<span className="required">*</span>
               </div>
               <div className="value">
                  <input
                     type="date"
                     id="cliente[8]"
                     value={cliente[8]}
                     onChange={(e) => handleClienteChange(8, e.target.value)}
                     style={{
                        fontSize: 16,
                        padding: "4px 12px",
                        borderRadius: 6,
                        border: "1px solid #bbb",
                     }}
                  />
                  <div className="dob_age" id="dob_age_display"></div>{" "}
                  <div id="age_note" className="under_age no_label">
                     Si tu estas bajo los<b>18</b> anos. Tu Pariente o guardian
                     legal deberan completar el formulario mas abajo.
                  </div>{" "}
               </div>
               <div className="break"></div>
               <div id="input_phone" className="label">
                  Telefono:<span className="required">*</span>
               </div>
               <div className="value">
                  <input
                     className="input_phone"
                     placeholder=""
                     id="cliente[3]"
                     name="cliente[3]"
                     type="phone"
                     autoComplete="off_72"
                     value={cliente[3]}
                     onChange={(e) => handleClienteChange(3, e.target.value)}
                  />
               </div>
               <div className="break"></div>
               <div id="input_email" className="label">
                  Correo Electronico:<span className="required">*</span>
               </div>
               <div className="value">
                  <input
                     className="input_email"
                     placeholder="tumail@gmail.com"
                     id="cliente[4]"
                     name="cliente[4]"
                     type="email"
                     autoComplete="off_92"
                     value={cliente[4]}
                     onChange={(e) => handleClienteChange(4, e.target.value)}
                  />
               </div>
               <div className="break"></div>
               {/* <div id="input_newsletter" style={{ clear: "both" }}>
                  {" "}
                  <input
                     className="newsletter_check"
                     type="checkbox"
                     name="newsletter"
                     checked="checked"
                  />
                  <span style={{ position: "relative", bottom: "0.5em" }}>
                     Subscribete a nuestro boletín informativo
                  </span>
               </div> */}
               <div className="break"></div>
               <div id="input_phone" className="label">
                  Identificador de redes sociales:{" "}
               </div>
               <div className="value">
                  <input
                     className="input_text"
                     placeholder="@"
                     id="cliente[5]"
                     name="cliente[5]"
                     type="text"
                     autoComplete="off_60"
                     value={cliente[5]}
                     onChange={(e) => handleClienteChange(5, e.target.value)}
                  />
               </div>
               <div id="age_note" className="under_age no_label">
                  Si no te importa que te etiquetemos en fotos en línea
               </div>
               <div className="break"></div>
               <div id="input_signature" className="label">
                  Firma:<span className="required">*</span>
               </div>
               {firmaClientePreview ? (
                  <div style={{ margin: "16px 0" }}>
                     <img
                        src={firmaClientePreview}
                        alt="Firma cliente"
                        style={{
                           maxWidth: "300px",
                           maxHeight: "120px",
                           border: "1px solid #ccc",
                           borderRadius: "8px",
                        }}
                     />
                  </div>
               ) : (
                  <div style={{ margin: "16px 0" }}>
                     <SignaturePad
                        canvasProps={{
                           width: 635,
                           height: 240,
                           style: {
                              border: "1px solid #aeaeaeff",
                              borderRadius: "8px",
                           },
                        }}
                        ref={clienteSignaturePadRef}
                     />
                     <button
                        type="button"
                        style={{ marginTop: "8px" }}
                        onClick={() => clienteSignaturePadRef.current.clear()}
                     >
                        Limpiar Firma Digital
                     </button>
                  </div>
               )}
               <label className="signature_type">
                  Firma arriba o escriba su nombre:
               </label>
               <input
                  type="text"
                  className="signature_text"
                  id="signature_client_input"
                  onKeyUp="writeCanvas('signature_client', this.value);"
                  maxLength="15"
                  value={cliente[7]}
                  onChange={(e) => handleClienteChange(7, e.target.value)}
               />
            </fieldset>

            {/* Sección del Tutor/Padre (solo si es menor de 18) */}
            {isUnder18 && (
               <fieldset>
                  <br />
                  <div
                     className="legend"
                     style={{ color: "#856404", fontWeight: "bold" }}
                  >
                     Información del Padre/Tutor Legal (Requerido para menores
                     de 18 años)
                  </div>
                  <div className="break"></div>

                  <div id="input_tutor_name" className="label">
                     Nombre del Padre/Tutor Legal:
                     <span className="required">*</span>
                  </div>
                  <div className="value">
                     <input
                        style={{
                           fontSize: 16,
                           padding: "4px 12px",
                           borderRadius: 6,
                           width: "50%",
                           border: "1px solid #bbb",
                        }}
                        placeholder="Nombre completo del padre o tutor legal"
                        type="text"
                        value={tutorName}
                        onChange={(e) => setTutorName(e.target.value)}
                     />
                  </div>
                  <div className="break"></div>

                  <div id="input_tutor_signature" className="label">
                     Firma del Padre/Tutor Legal:
                     <span className="required">*</span>
                  </div>

                  {firmaTutorPreview ? (
                     <div style={{ margin: "16px 0" }}>
                        <img
                           src={firmaTutorPreview}
                           alt="Firma tutor"
                           style={{
                              maxWidth: "300px",
                              maxHeight: "120px",
                              border: "1px solid #ccc",
                              borderRadius: "8px",
                           }}
                        />
                     </div>
                  ) : (
                     <div style={{ margin: "16px 0" }}>
                        <SignaturePad
                           canvasProps={{
                              width: 635,
                              height: 240,
                              style: {
                                 border: "1px solid #aeaeaeff",
                                 borderRadius: "8px",
                              },
                           }}
                           ref={tutorSignaturePadRef}
                        />
                        <button
                           type="button"
                           style={{ marginTop: "8px" }}
                           onClick={() => tutorSignaturePadRef.current.clear()}
                        >
                           Limpiar Firma del Tutor
                        </button>
                     </div>
                  )}

                  <div
                     style={{
                        margin: "16px 0",
                        padding: "12px",
                        backgroundColor: "#057286ff",
                        border: "1px solid #bee5eb",
                        borderRadius: "6px",
                        fontSize: "14px",
                     }}
                  >
                     <strong>Nota:</strong> Como padre/tutor legal, certifico
                     que doy mi consentimiento para que se realice el
                     procedimiento de perforación corporal al menor mencionado
                     en este documento. Entiendo todos los riesgos y cuidados
                     posteriores explicados.
                  </div>
               </fieldset>
            )}

            {showDeclaroModal && (
               <div
                  style={{
                     position: "fixed",
                     top: 0,
                     left: 0,
                     // width: "100vw",
                     height: "100vh",
                     background: "rgba(0,0,0,0.7)",
                     zIndex: 9999,
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                  }}
                  onClick={() => setShowDeclaroModal(false)}
               >
                  <div
                     style={{
                        background: "#fff",
                        padding: "32px",
                        borderRadius: "16px",
                        maxWidth: "900px",
                        maxHeight: "80vh",
                        overflowY: "auto",
                        fontSize: "2em",
                        boxShadow: "0 4px 32px rgba(0,0,0,0.3)",
                     }}
                     onClick={(e) => e.stopPropagation()}
                  >
                     {declaroText}
                     <div style={{ textAlign: "right", marginTop: "24px" }}>
                        <button
                           style={{ fontSize: "1.2em", padding: "8px 24px" }}
                           onClick={() => setShowDeclaroModal(false)}
                        >
                           Cerrar
                        </button>
                     </div>
                  </div>
               </div>
            )}

            {/* Imagen upload section */}
            <fieldset>
               <br />
               <div className="legend">Foto de Identificación</div>
               <b>
                  Por Favor Tome fotografías de sus documentos de identidad con
                  fotografía emitidos por el gobierno y de la documentación
                  relacionada.
               </b>
               <br />

               {!showWebcam ? (
                  <div style={{ marginTop: "16px" }}>
                     <button
                        type="button"
                        style={{
                           fontSize: "1.2em",
                           padding: "10px 24px",
                           marginRight: "12px",
                           backgroundColor: hasCamera ? "#007bff" : "#6c757d",
                           color: "white",
                           border: "none",
                           borderRadius: "6px",
                           cursor: hasCamera ? "pointer" : "not-allowed",
                        }}
                        onClick={openWebcam}
                        disabled={!hasCamera}
                     >
                        📷 Tomar Otra Foto ({imagenes.length})
                        {!hasCamera && " (Sin cámara)"}
                     </button>

                     {imagenes.length > 0 && (
                        <button
                           type="button"
                           style={{
                              fontSize: "1.0em",
                              padding: "8px 16px",
                              backgroundColor: "#dc3545",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                           }}
                           onClick={limpiarTodasImagenes}
                        >
                           🗑️ Limpiar Todas
                        </button>
                     )}

                     {/* Información sobre el estado de la cámara */}
                     <div
                        style={{
                           marginTop: "8px",
                           fontSize: "0.9em",
                           color: "#666",
                        }}
                     >
                        {hasCamera
                           ? `Cámara detectada - Modo: ${
                                facingMode === "user" ? "Frontal" : "Trasera"
                             }`
                           : "Verificando disponibilidad de cámara..."}
                     </div>
                  </div>
               ) : (
                  <div style={{ marginTop: "16px", textAlign: "center" }}>
                     <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={400}
                        height={300}
                        videoConstraints={{
                           width: 400,
                           height: 300,
                           facingMode: facingMode,
                        }}
                        style={{
                           border: "2px solid #ccc",
                           borderRadius: "8px",
                        }}
                        key={`${facingMode}-${Date.now()}`} // Forzar re-render
                     />

                     <div style={{ marginTop: "12px" }}>
                        <button
                           type="button"
                           style={{
                              fontSize: "1.0em",
                              padding: "5px 10px",
                              marginRight: "12px",
                              backgroundColor: "#28a745",
                              color: "white",
                              border: "none",
                              borderRadius: "6px",
                              cursor: "pointer",
                           }}
                           onClick={capture}
                        >
                           📸 Capturar Foto
                        </button>

                        <button
                           type="button"
                           style={{
                              fontSize: "1.0em",
                              padding: "5px 10px",
                              marginRight: "12px",
                              backgroundColor: "#ffc107",
                              color: "black",
                              border: "none",
                              borderRadius: "6px",
                              cursor: "pointer",
                           }}
                           onClick={switchCamera}
                        >
                           🔄{" "}
                           {facingMode === "user"
                              ? "Cámara Trasera"
                              : "Cámara Frontal"}
                        </button>

                        <button
                           type="button"
                           style={{
                              fontSize: "1.0em",
                              padding: "5px 10px",
                              backgroundColor: "#dc3545",
                              color: "white",
                              border: "none",
                              borderRadius: "6px",
                              cursor: "pointer",
                           }}
                           onClick={closeWebcam}
                        >
                           ❌ Cancelar
                        </button>
                     </div>

                     {/* Indicador del modo de cámara activo */}
                     <div
                        style={{
                           marginTop: "8px",
                           fontSize: "0.9em",
                           color: "#007bff",
                        }}
                     >
                        Cámara {facingMode === "user" ? "Frontal" : "Trasera"}{" "}
                        activa
                     </div>
                  </div>
               )}

               {/* Mostrar todas las imágenes capturadas */}
               {imagenes.length > 0 && (
                  <div style={{ marginTop: "16px" }}>
                     <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                        Fotos capturadas ({imagenes.length}):
                     </div>
                     <div
                        style={{
                           display: "flex",
                           flexWrap: "wrap",
                           gap: "12px",
                        }}
                     >
                        {imagenes.map((imagen, index) => (
                           <div
                              key={imagen.id}
                              style={{
                                 position: "relative",
                                 border: "1px solid #ccc",
                                 borderRadius: "8px",
                                 padding: "8px",
                                 backgroundColor: "#f9f9f9",
                              }}
                           >
                              <div
                                 style={{
                                    fontSize: "12px",
                                    marginBottom: "4px",
                                    color: "#666",
                                 }}
                              >
                                 Foto #{index + 1}
                              </div>
                              <img
                                 src={imagen.data}
                                 alt={`Foto ${index + 1}`}
                                 style={{
                                    width: "200px",
                                    height: "150px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                 }}
                              />
                              <button
                                 type="button"
                                 style={{
                                    position: "absolute",
                                    top: "4px",
                                    right: "4px",
                                    backgroundColor: "#dc3545",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "24px",
                                    height: "24px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                 }}
                                 onClick={() => eliminarImagen(imagen.id)}
                              >
                                 ✕
                              </button>
                           </div>
                        ))}
                     </div>
                  </div>
               )}
            </fieldset>
            {grabar && (
               <button
                  // type="submit"
                  style={{
                     margin: "24px 0",
                     padding: "12px 32px",
                  }}
                  onClick={handleSubmit}
               >
                  Enviar
               </button>
            )}
         </form>
         <button
            onClick={() => {
               enviarEmail();
            }}
            style={{
               margin: "24px 0",
               padding: "12px 32px",
            }}
         >
            Mail
         </button>
      </>
   );
}
